import authHeader from "../../Model/Common/AuthHeader"
import { httpClient } from "../../Model/Common"

const ReceiptService = {

    findReceipts() {
        return httpClient.get("/workers/receipts", { headers: authHeader() })
    },

    handOverReceipts(receiptIds) {
        return httpClient.post("/workers/receipts/handover", { receiptIds }, { headers: authHeader() })
    },

}

export default ReceiptService
